/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type SearchBar_viewer$ref = any;
export type SearchBar_viewer = {
    readonly isSuggestionsFeatureEnabled: boolean | null;
    readonly searchSuggestions?: {
        readonly suggestions: ReadonlyArray<{
            readonly type: string | null;
            readonly terms: ReadonlyArray<{
                readonly term: string | null;
                readonly urlLabel: string | null;
            } | null> | null;
        } | null> | null;
    } | null;
    readonly user?: {
        readonly recentHistoryList: ReadonlyArray<{
            readonly eventDate: string | null;
            readonly item: {
                readonly contemporaryTrackingString: string;
                readonly firstPhotoWebPath: string | null;
                readonly pdpURL: string | null;
                readonly title: string | null;
                readonly browseUrl: string | null;
                readonly categoryCode: string | null;
                readonly serviceId: string | null;
                readonly categoryPath: string | null;
                readonly seller: {
                    readonly serviceId: string | null;
                } | null;
            } | null;
        } | null> | null;
    } | null;
    readonly " $refType": SearchBar_viewer$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceId",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "SearchBar_viewer",
        "type": "Viewer",
        "metadata": null,
        "argumentDefinitions": [
            {
                "kind": "LocalArgument",
                "name": "query",
                "type": "String!",
                "defaultValue": ""
            },
            {
                "kind": "LocalArgument",
                "name": "hasQuery",
                "type": "Boolean!",
                "defaultValue": false
            },
            {
                "kind": "LocalArgument",
                "name": "hasUserRecentHistory",
                "type": "Boolean!",
                "defaultValue": false
            },
            {
                "kind": "RootArgument",
                "name": "userId",
                "type": "String!"
            },
            {
                "kind": "RootArgument",
                "name": "hasUserId",
                "type": "Boolean"
            }
        ],
        "selections": [
            {
                "kind": "ScalarField",
                "alias": "isSuggestionsFeatureEnabled",
                "name": "isEnabledByLocale",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "featureName",
                        "value": "SEARCH_BAR_SUGGESTIONS"
                    }
                ],
                "storageKey": "isEnabledByLocale(featureName:\"SEARCH_BAR_SUGGESTIONS\")"
            },
            {
                "kind": "Condition",
                "passingValue": true,
                "condition": "hasQuery",
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "searchSuggestions",
                        "storageKey": null,
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "includeTypes",
                                "value": [
                                    "POPULAR",
                                    "CATEGORY",
                                    "SELLER"
                                ]
                            },
                            {
                                "kind": "Variable",
                                "name": "query",
                                "variableName": "query"
                            }
                        ],
                        "concreteType": "SearchSuggestion",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "suggestions",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "SearchSuggestionList",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "type",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "terms",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "SearchSuggestionTerm",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "term",
                                                "args": null,
                                                "storageKey": null
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "urlLabel",
                                                "args": null,
                                                "storageKey": null
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "Condition",
                "passingValue": false,
                "condition": "hasUserRecentHistory",
                "selections": [
                    {
                        "kind": "Condition",
                        "passingValue": true,
                        "condition": "hasUserId",
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "user",
                                "storageKey": null,
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "userId",
                                        "variableName": "userId"
                                    }
                                ],
                                "concreteType": "User",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "recentHistoryList",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "RecentHistoryItem",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "eventDate",
                                                "args": null,
                                                "storageKey": null
                                            },
                                            {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "item",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "Item",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "alias": null,
                                                        "name": "contemporaryTrackingString",
                                                        "args": null,
                                                        "storageKey": null
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "alias": null,
                                                        "name": "firstPhotoWebPath",
                                                        "args": [
                                                            {
                                                                "kind": "Literal",
                                                                "name": "size",
                                                                "value": "small"
                                                            }
                                                        ],
                                                        "storageKey": "firstPhotoWebPath(size:\"small\")"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "alias": null,
                                                        "name": "pdpURL",
                                                        "args": null,
                                                        "storageKey": null
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "alias": null,
                                                        "name": "title",
                                                        "args": null,
                                                        "storageKey": null
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "alias": null,
                                                        "name": "browseUrl",
                                                        "args": null,
                                                        "storageKey": null
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "alias": null,
                                                        "name": "categoryCode",
                                                        "args": null,
                                                        "storageKey": null
                                                    },
                                                    (v0 /*: any*/),
                                                    {
                                                        "kind": "ScalarField",
                                                        "alias": null,
                                                        "name": "categoryPath",
                                                        "args": null,
                                                        "storageKey": null
                                                    },
                                                    {
                                                        "kind": "LinkedField",
                                                        "alias": null,
                                                        "name": "seller",
                                                        "storageKey": null,
                                                        "args": null,
                                                        "concreteType": "Seller",
                                                        "plural": false,
                                                        "selections": [
                                                            (v0 /*: any*/)
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = 'abcb14422b7629b72cf9b69c9aa3f9ed';
export default node;
